import { IRootState } from '@/store'
import { ActionContext } from 'vuex'

export interface INotificationFetchRequest {
    id: string,
    shippingIds: string[]
}

export interface INotificationReadRequest {
    userId: string,
    notificationId: string
}

export interface INotification {
    icon: number
    notificationId: string,
    longDescription: string,
    shortDescription:string,
    title: string,
    createdOn: string,
    readNotification: boolean,

}

export enum INotificationActionsTypes {
    'FETCH_NOTIFICATIONS' = 'FETCH_NOTIFICATIONS',
    'UPDATE_NOTIFICATION' = 'UPDATE_NOTIFICATION'
}

export enum INotificationMutationTypes {
    'SET_LOADING' = 'SET_LOADING',
    'SET_NOTIFICATION' = 'SET_NOTIFICATION',
}

export interface INotificationState {
    loading: boolean,
    notifications: INotification[],
}

export type INotificationMutation<S = INotificationState> = {
    [INotificationMutationTypes.SET_LOADING](state: S, payload: boolean): void
    [INotificationMutationTypes.SET_NOTIFICATION](state: S, payload: any): void
}

export type AugmentedAuthActionType = {

    commit<K extends keyof INotificationMutation>(
      key: K,
      payload: Parameters<INotificationMutation[K]>[1]
    ): ReturnType<INotificationMutation[K]>
  } & Omit<ActionContext<INotificationState, IRootState>, 'commit'>

export type INotificationAction = {
    [INotificationActionsTypes.FETCH_NOTIFICATIONS]({ commit }: AugmentedAuthActionType, payload: any): void,
    [INotificationActionsTypes.UPDATE_NOTIFICATION]({ commit }: AugmentedAuthActionType, payload: any): void,

}
